import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { SERVER_PATH } from "../../config/env";
import Sidebar from "../Sidebar";

import { ToastContainer, toast } from "react-toastify";
import { Breadcrumbs } from "./../Breadcrumb/index";
import apiClient from "../../utils/api";

export default function Notification() {
  let initNotification = {
    user_id: "",
    content: "",
    link: "",
  };

  const url = `post/notification.php`;

  const [data, setData] = useState(initNotification);

  const dataHandler = async (e) => {
    const arr = { ...data };
    arr[e.target.name] = e.target.value;
    setData(arr);
  };

  const dataSubmit = async (e) => {
    e.preventDefault();
    let info = { ...data };
    apiClient
      .post(url, {
        ...info,
      })
      .then((res) => {
        setData(initNotification);
        toast.success("Notification Send Successful", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {" "}
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }}>
            <Row className="p-2">
              <Col className="slidesContent rounded shadow p-3 bg-light">
                <Breadcrumbs currentPathName="Notifications" />
                <Form onSubmit={dataSubmit}>
                  <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridEmail">
                      <Form.Label>USER ID</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter user ID"
                        name="user_id"
                        value={data.user_id}
                        onChange={(e) => dataHandler(e)}
                      />
                    </Form.Group>
                  </Row>

                  <Form.Group className="mb-3" controlId="formGridAddress1">
                    <Form.Label>MESSAGE</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Enter message"
                      name="content"
                      value={data.content}
                      onChange={(e) => dataHandler(e)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formGridAddress1">
                    <Form.Label>PRODUCT LINK</Form.Label>
                    <Form.Control
                      placeholder="Enter product link"
                      name="link"
                      value={data.link}
                      onChange={(e) => dataHandler(e)}
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
}
